import axios from 'axios'
type TDataVersionResponse = {
  version: string
}

export const getVersion = async () => {
  const { data } = await axios.get<TDataVersionResponse>(`${location.origin}/version.json`)
  return data.version
}
